module.exports = __webpack_public_path__ + "static/media/close.ff987521.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 202
// module chunks = 0